import getStore from '../store/store';

export default function getSpotlightRowKeyFromItemId(itemId: string): string {
    const spotlightItem = getStore().spotlightItems.filter(
        spotlightItem => spotlightItem.itemId === itemId
    )[0];
    return spotlightItem?.rowKey;
}
